import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
const main = () => import("@/components/main"); //导航栏
const home = () => import("@/components/home"); //首页内容


const mynews = () => import("@/components/page/my_news"); //新闻
const mycase = () => import("@/components/page/my_case"); 
const myus = () => import("@/components/page/my_us"); 


// const menutwo = () => import("@/components/base_business/menu_two");  //菜单内容设置
// const sys_update_log = () => import("@/components/base_business/sys_updatelog"); //后台关键更新日志
// const app_update = () => import("@/components/base_business/app_update"); //后台关键更新日志


Vue.use(Router)

const router = new Router({
  mode: "history",
  // base: getAbsolutePath(),
  // base: "/app/",
  routes: [
    {
      // 首先进行重定向操作
      path: "/",
      redirect: "main"
    },
    {
      path: "/main",
      name: "main",
      component: main,
      meta: {
        title: "陕西领科新能源科技有限公司",
        content: "",
        description: ""
      },
      children: [
        {
          name: "home",
          path: "/home",
          component: home,
          meta: {
            requiresAuth: true,
            title: "陕西领科新能源科技有限公司"
          }
        }
		,
		{
		  name: "mynews",
		  path: "/mynews",
		  component: mynews,
		  meta: {
		    requiresAuth: true,
		    title: "新闻资料"
		  }
		},
		{
		  name: "mycase",
		  path: "/mycase",
		  component: mycase,
		  meta: {
		    requiresAuth: true,
		    title: "项目案例"
		  }
		},
		{
		  name: "myus",
		  path: "/myus",
		  component: myus,
		  meta: {
		    requiresAuth: true,
		    title: "关于我们"
		  }
		}

      ]
    },
	
	
      
	  
    { path: "*", component: main }
  ]
});

// 根据路径名称动态匹配，非根路径时使用
function getAbsolutePath() {
  let path = location.pathname;
  return path.substring(0, path.lastIndexOf("/") + 1);
}

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // console.log(to);
  // console.log(from);
  // console.log("navigation-guards");
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  // console.log('跳转to  ='+to+'  from='+from+'  next='+next);
  document.title = to.meta.title || "Unknow title";
  let head = document.getElementsByTagName("head");
  let meta = document.createElement("meta");
  meta.content =
    "陕西领科新能源科技有限公司" || "Unknow keywords";
  head[0].appendChild(meta);

  // next() //直接进to 所指路由
  // next(false) //中断当前路由
  // next('route') //跳转指定路由
  // next('error') //跳转错误路由
  // if (from.name == null) {
  //   console.log('外部跳入===========');
  //   // console.log(to.path);
  //   // console.log(to.query);
  //   // console.log(JSON.stringify(to.query));

  //   // 路由这里有点小问题。
  //   try {
  //     if (String(JSON.stringify(to.query)) != 'undefined') {
  //       localStorage.setItem('path', to.path);
  //       localStorage.setItem('query', JSON.stringify(to.query));
  //     }
  //   } catch (e) {

  //   }


  // }


  next();
});


export default router;
